import React from 'react'
import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ModalBottom } from '@ui/components/Modal'
import Button from '@ui/buttons/Button'
import Typography from '@ui/typography'
import { NextStep } from '@order/utils/getNextStepHref'
import { router } from 'expo-router'

export interface OptionConfirmModalProps {
  open: boolean
  title: string
  desc: string
  href: NextStep | undefined
  onPress?: () => void
  option: string
  close: () => void
}

export default function OptionConfirmModal({
  open,
  close,
  href,
  onPress,
  option,
  title,
  desc,
}: OptionConfirmModalProps) {
  const { t } = useTranslation(['ui', 'modals'])

  return (
    <ModalBottom
      center
      open={open}
      close={close}
      title={title || t('modals:option.confirm.title')}
      desc={desc || t('modals:option.confirm.desc')}
      body={
        <View className="px-16 py-0">
          <View className="bg-gray-75 flex items-center justify-center rounded-2xl border border-black/10 px-16 py-16">
            <Typography variant="LG" className="uppercase tracking-widest">
              {option}
            </Typography>
          </View>
        </View>
      }
      buttons={
        <>
          <Button
            variant="outlined"
            onPress={close}
            label={t('modals:option.confirm.button.close')}
            iconEnd="x"
          />
          <Button
            variant="outlined"
            onPress={() => {
              onPress?.()
              !!href && router.push(href)
              close()
            }}
            label={t('modals:option.confirm.button.accept')}
            iconEnd="arrow-narrow-right"
          />
        </>
      }
    />
  )
}
